<template>
  <div class="box-t">
    <m-upload-multi-address></m-upload-multi-address>
    <m-question :link="$store.getters['config/link']('radiusQuestion') + '&siteId=' + $store.state.site.SiteId"></m-question>
    <div class="header">
      <h3>
        Radius around an Address or City
      </h3>
    </div>
    <b-container fluid>
      <div :class="{'map-full-screen-input': fullScreen}">
        <b-row>
          <b-col md="7" class="inputcol m-col-top" sm="12">
            <input id="radius-address"
                   @keyup.enter="search"
                   @change="addressChange($event)"
                   placeholder="Enter an address, city or ZIP code"
                   class="address-input form-control"
                   v-model="address" />
          </b-col>
          <b-col md="5" class="flex-center m-col-top" sm="12" style="padding-left: 0">
            <span style="margin-right: 16px">Granularity</span>
            <b-form-select
              class="address-input"
              :disabled="granularityDisable"
              data-test="geo-radius-granularity"
              v-model="granularity">
              <option value="1" checked>Standard</option>
              <option value="2" v-show="showZip4">ZIP4</option>
              <option value="3">Carrier Route</option>
              <option value="4">ZIP Code</option>
            </b-form-select>
            <icon name="question-circle"
                  title="help"
                  style="color: #e04557; height:24px; margin-left: 16px;width:36px; cursor: pointer "
                  @click.native="showQuestion"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="padding-left: 0">
            <div class="action-box">
              <div class="qty-box">
                <b-form-radio-group v-model="selectedType"
                                    data-test="geo-radius-type"
                                    plain
                                    @change="radiusTypeChange($event)"
                                    class="qty-radio">
                  <b-form-radio value="radius">Radius (miles)</b-form-radio>
                  <b-form-radio value="quantity" v-if="hasCloseX"> Closest prospects (quantity)</b-form-radio>
                </b-form-radio-group>
                <b-input class="qty-input"
                         @change="quantityChange"
                         data-test = 'geo-radius-qty'
                         v-model="inputvalue"></b-input>
                Address Name:
                <b-input class="name-input"
                          data-test = 'geo-radius-qty'
                          v-model="name"></b-input>
                <b-btn @click="drawingRadius"
                       data-test="geo-radius-add"
                       :disabled="radiusDisable">Add</b-btn>
              </div>
              <!--<div v-show="!fullScreen">-->
                <!--<b-btn @click="goBack">Back</b-btn>-->
                <!--<b-btn :disabled ="nextDisabled"-->
                       <!--@click ="next">Next</b-btn>-->
              <!--</div>-->
            </div>
          </b-col>
        </b-row>
      </div>
      <b-row style="margin-top: 0">
        <b-col style="padding-left: 0">
          <b-link @click="uploadFile"
                  v-if="hasMulti"
                  :disabled="radiusDisable"
                  style="margin-right: 32px;margin-bottom: 8px">> Upload file with multiple addresses
          </b-link>
          <b-form-checkbox v-model="breakdown"
                           v-if="datasource.hasBreakDown"
                           style="margin-right: 32px">See breakdown with my results</b-form-checkbox>
          <b-form-checkbox v-model="sameState" v-if="datasource.code != 150 && datasource.code != 160 && datasource.code != 250 && datasource.code != 260 && datasource.code != 50">Do not cross state lines</b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="circle">
        <b-col>
          <div id="maps"class="circle">
            <b-alert :show="alertDesc!==''" variant="warning">{{alertDesc}}</b-alert>
            <m-map map-id = 'mapCircle'
                   @load="createMap"
                   @full-screen="toggleFullScreen"></m-map>
            <br />
            <div v-for="(item, index) in orderaddress" v-if="item.AddrUsageType===2 && geoType !== 12"><span @click="mapPanto(item, index)" style="cursor: pointer">{{item.AddressLine}}</span><span @click="deleteGeo(item.AddrSearchString)" style="color: red; margin-left: 8px;">
                <icon
                  name="times-circle"
                  class="times-icon"/>
              </span> </div>
            <div class="self-btns">
              <b-btn @click = "clearCircle">Clear</b-btn>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import MMap from '@/components/geo/MMap'
  import utils from '@/assets/utils/index'
  import MUploadMultiAddress from '@/components/geo/MUploadMultiAddress'
  import MQuestion from '@/components/common/Mquestion'
  import _ from 'lodash'

  export default {
    components: {
      MGeoBox,
      MMap,
      MUploadMultiAddress,
      MQuestion
    },
    data () {
      return {
        inputvalue: '',
        map: null,
        autocomplete: null,
        place: {},
        markers: [],
        selectedType: 'radius',
        addressSameState: true,
        address: '',
        circleMaps: [],
        alertDesc: '',
        granularityDisable: false,
        fullScreen: false,
        name: ''
      }
    },
    computed: {
      orderaddress () {
        if (this.geoType === 16 || this.geoType === 7) {
          return _.filter(this.$store.getters['order/orderaddress'], item => {
            return item.AddrUsageType === 2
          })
        } else {
          return this.$store.getters['order/orderaddress']
        }
      },
      geoType () {
        return this.$store.state.order.GeoType
      },
      showZip4 () {
        return this.$store.state.order.ListType !== 50
      },
      granularity: {
        get () {
          let choice = this.$store.state.order.RadiusTypeChoice
          if (choice === null) {
            return 1
          }
          return choice
        },
        set (val) {
          this.$store.commit('order/saveKey', ['RadiusTypeChoice', parseInt(val)])
        }
      },
      breakdown: {
        get () {
          return this.$store.state.order.SeeBreakDown
        },
        set (val) {
          this.$store.commit('order/saveKey', ['SeeBreakDown', val])
        }
      },
      sameState: {
        get () {
          return this.$store.state.order.GeoSameState
        },
        set (val) {
          this.addressSameState = val
          this.$store.commit('order/saveKey', ['GeoSameState', this.addressSameState])
          this.$store.commit('order/UpdateAddressSameState', val)
        }
      },
      geoItems () {
        return this.$store.getters['order/geoItems']
      },
      nextDisabled () {
        if (this.$store.state.order.CurrentStep === 'count') {
          return true
        }
        if (this.geoItems.length === 0 && this.orderaddress.length === 0) {
          return true
        }
        return false
      },
      datasource () {
        return this.$store.getters['config/datasource']
      },
      hasCloseX () {
        if (this.datasource && this.datasource.geoRadius) {
          return this.datasource.geoRadius.indexOf('closex') > 0
        } else {
          return false
        }
      },
      hasMulti () {
        if (this.datasource && this.datasource.geoRadius) {
          return this.datasource.geoRadius.indexOf('multi') > 0
        } else {
          return false
        }
      },
      radiusDisable () {
        if (this.selectedType === 'radius') {
          let geoCode = this.$store.state.geo.geoTypes.Radius.Code
          if (!this.hasMulti && this.orderaddress.length > 0) {
            if (this.geoType === geoCode) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        } else if (this.orderaddress.length === 0) {
          return false
        } else {
          return true
        }
      }
    },
    watch: {
      orderaddress () {
        this.updateMap()
      }
    },
    methods: {
      clearCircle () {
        this.$store.commit('order/cleanGeo')
        for (let item of this.circleMaps) {
          item.setMap(null)
        }
      },
      back () {
        for (let item of this.circleMaps) {
          item.setMap(null)
        }
      },
      uploadFile () {
        this.$root.$emit('bv::show::modal', 'modaluploadmultiaddress')
      },
      drawingRadius () {
        this.$store.commit('geo/saveKey', ['geoUnAdd', false])
        this.alertDesc = ''
        if (this.address === '' || this.inputvalue === null) {
          this.alertDesc = 'Please Input an address/radius/quantity.'
          return false
        }

        if (this.selectedType === 'radius' && (isNaN(this.inputvalue) || !this.inputvalue || this.inputvalue <= 0)) {
          this.alertDesc = 'Radius must be a number and greater than 0'
          return false
        }
        if (this.selectedType === 'quantity' && (isNaN(this.inputvalue) || !this.inputvalue || this.inputvalue <= 0)) {
          this.alertDesc = 'Quantity must be an integer and greater than 0'
          return false
        }
        if (this.selectedType === 'radius') {
          let geoCode = this.$store.state.geo.geoTypes.AcxiomMultiRadius.Code
          if (this.$store.state.order.ListType === 50) {
            geoCode = this.$store.state.geo.geoTypes.Radius.Code
          }
          if (this.geoType !== 7 && this.geoType !== 16) {
            this.$store.dispatch('order/changeGeoType', geoCode)
          }
          if (this.place === null) {
            let that = this
            this.map.textSearch(this.address, resp => {
              if (resp.placesresult !== null) {
                that.place = { lat: resp.placesresult.geometry.location.lat(), lng: resp.placesresult.geometry.location.lng() }
                this.commitGeo(that.place, geoCode)
                that.markers.push(resp.marker)
              } else {
                this.alertDesc = 'No results found for address'
              }
            })
          } else {
            this.commitGeo(this.place, geoCode)
          }
        } else {
          this.quantityChange()
        }
      },
      onPlaceChanged () {
        var place = this.autocomplete.getPlace()
        if (place.geometry) {
          this.map.map.setZoom(12)
          this.map.map.panTo(place.geometry.location)
          /* eslint-disable*/
          var m = new google.maps.Marker({
            position: place.geometry.location,
            center: place.geometry.location,
            map: this.map.map
          })
          this.markers.push(m)
          this.place = {lat: place.geometry.location.lat(), lng: place.geometry.location.lng() }
          this.address = document.getElementById('radius-address').value
        } else {
          document.getElementById('radius-address').placeholder = 'Enter a ZIP Code/Address'
        }
      },
      createMap () {
        this.map = utils.maps['mapCircle']
        /* eslint-disable no-undef */
        this.autocomplete = new google.maps.places.Autocomplete((
            document.getElementById('radius-address')), {
            types: ['(regions)'],
            componentRestrictions: {'country': 'us'}
          }
        )
        // let places = new google.maps.places.PlacesService(this.map)
        this.autocomplete.addListener('place_changed', this.onPlaceChanged)
        this.updateMap()
        this.initMap()
      },
      radiusTypeChange (e) {
        if (e === 'radius') {
          this.selectedType = 'radius'
          if (this.inputvalue !== '' && this.address !== '') {
            this.drawingRadius()
          }
        } else {
          this.selectedType = 'quantity'
          if (this.inputvalue !== '' && this.address !== ''){
            this.quantityChange()
          }
        }
      },
      addressChange (e) {
        this.$store.commit('geo/saveKey', ['geoUnAdd', 'radius'])
        let that = this
        if (this.selectedType === 'quantity' && this.inputvalue !== '' && this.address !== '') {
          if (this.place === null) {
            this.map.textSearch(this.address,  (result) => {
              this.place = {lat: result.placesresult.geometry.location.lat(), lng: result.placesresult.geometry.location.lng() }
              that.commitGeo(this.place, this.$store.state.geo.geoTypes.Closex.Code)
              that.markers.push(result.marker)
            })
          }
        }  
        if (this.selectedType === 'radius' && this.place !== null) {
          this.place = null
        }
      },
      quantityChange () {
        let that = this
        if (this.selectedType === 'quantity' && this.address !== '') {
          let geoCode = this.$store.state.geo.geoTypes.Closex.Code
          this.$store.dispatch('order/changeGeoType', geoCode)
          if ((isNaN(this.inputvalue) || !this.inputvalue || !Number.isInteger(Number(this.inputvalue)) || this.inputvalue <= 0)) {
            this.alertDesc = 'Quantity must be an integer and greater than 0'
            return false
          }
          this.map.textSearch(this.address,  (result) => {
              this.markers.push((result.marker))
              this.place = {lat: result.placesresult.geometry.location.lat(), lng: result.placesresult.geometry.location.lng() }
              that.commitGeo(this.place, geoCode)
          })
        } else if (this.selectedType === 'radius' && this.place !== null) {  
          if (this.inputvalue > 200) {
            this.inputvalue = 200
          }
          let circles = this.map.initCircleDrawing([{
            Radius: Number(this.inputvalue),
            AddrSearchString: '',
            AddressLine: this.address,
            AddressName: this.name || this.address,
            Latitude: this.place.lat,
            Longitude: this.place.lng,
            Quantity: 0,
            SameState: this.addressSameState
          }], false)
          for(let item of circles) {
            this.circleMaps.push(item)
          }
        }
      },
      commitGeo (result, geoType) {
        this.alertDesc = ''
        if (result !== null) {
          if (geoType === this.$store.state.geo.geoTypes.Closex.Code) {
            this.$store.commit('order/cleanGeo')
          }
          let radius = 0
          let quantity = 0
          if (this.selectedType === 'quantity') {
            quantity = this.inputvalue
          } else {
            if (this.inputvalue > 200) {
              this.inputvalue = 200
            }
            radius = this.inputvalue
          }
          if (this.orderaddress.length >= 1) {
            if (this.name === '') {
              this.alertDesc = 'Please Enter Address Name'
              return
            }
            let temp = _.filter(this.orderaddress, item => {
              return item.AddressName === this.name
            })
            if (temp.length > 0 && temp[0].AddrSearchString.split(':')[0] != this.place.lng && temp[0].AddrSearchString.split(':')[1] != this.place.lat ) {
              this.alertDesc = 'Address Name already exists, please change one'
              return
            }
          }
          let searchstring = this.place.lng + ':' + this.place.lat + ':'+ this.inputvalue +':2'
          this.$store.commit('order/addAddress', {
            Radius: Number(radius),
            AddrSearchString: searchstring,
            AddressLine: this.address,
            AddressName: this.name || this.address,
            Latitude: this.place.lat,
            Longitude: this.place.lng,
            Quantity: quantity,
            SameState: this.addressSameState
          })
          this.$store.commit('order/addGeo', {
            AddressLine: searchstring,
            GeoKeyCode: searchstring,
            GeoKeyDesc: this.address,
            GeoType: geoType
          })
        }
        else  {
          this.alertDesc = 'Please note: The address entered was not found '
        }
      },
      showQuestion () {
        this.$root.$emit('bv::show::modal', 'question')
      },
      next () {
        this.$store.dispatch('geo/next')
      },
      goBack () {
        this.$router.go(-1)
      },
      search () {
        let that = this
        this.map.textSearch(this.address, resp => {
          if (resp.placesresult !== null) {
            that.place = {lat: resp.placesresult.geometry.location.lat(), lng: resp.placesresult.geometry.location.lng()} 
            that.markers.push(resp.marker)
          } else {
            that.alertDesc = 'No results found for address'
          }
        })
      },
      toggleFullScreen (val) {
        this.fullScreen = val
      },
      updateMap () {
        console.log(this.circleMaps)
        // Avoid update map in other page
        if (this.$route.name !== 'geo-radius') {
          return
        }
        for (let item of this.markers) {
          if (item) {
            item.setMap(null)
          }
        }
        for (let item of this.circleMaps) {
          if (item.c) {
            item.c.setMap(null)
          }
          if (item.m && item.m !== null) {
            item.m.setMap(null)
          }
        }
        // GeoType set single radius
        if (this.orderaddress.length === 1 && this.geoType === this.$store.state.geo.geoTypes.AcxiomMultiRadius.Code) {
          this.granularityDisable = false
          this.$store.commit('order/changeGeoType', this.$store.state.geo.geoTypes.Radius.Code)
        }

        // GeoType set mult radius
        if (this.orderaddress.length >= 2 && this.geoType === this.$store.state.geo.geoTypes.Radius.Code) {
          this.granularityDisable = true
          this.$store.commit('order/changeGeoType', this.$store.state.geo.geoTypes.AcxiomMultiRadius.Code)
        }
        if (this.geoType === 16 || this.geoType === 7) {
          this.circleMaps = this.map.initCircleDrawing(this.orderaddress, true) || []
          this.$store.commit('geo/saveCircles', this.circleMaps)
        }
      },
      initMap () {
        // Update Map
        if (this.orderaddress.length > 0) {
          // radius
          if (this.geoType === 16 || this.geoType === 7) {
            this.address = this.orderaddress[0].AddressLine
            this.inputvalue = this.orderaddress[0].Radius
            this.name = this.orderaddress[0].AddressName
            this.place = {lat: this.orderaddress[0].AddrSearchString.split(':')[1], lng: this.orderaddress[0].AddrSearchString.split(':')[0] }
          } else if (this.geoType === 12) {            // closeX
            this.address = this.orderaddress[0].AddressLine
            this.inputvalue = this.orderaddress[0].Quantity
            this.selectedType = 'quantity'
            this.place = {lat: this.orderaddress[0].AddrSearchString.split(':')[1], lng: this.orderaddress[0].AddrSearchString.split(':')[0] }
            this.markers.push(this.map.marker({lat: Number(this.orderaddress[0].Latitude), lng: Number(this.orderaddress[0].Longitude)}))
            this.map.map.setCenter({lat: Number(this.orderaddress[0].Latitude), lng: Number(this.orderaddress[0].Longitude)})
            this.map.map.setZoom(12)
          }
        }
      },
      mapPanto (address,index) {
        // this.map.map.setZoom(12) circleMaps
        this.map.map.fitBounds(this.circleMaps[index].c.getBounds())
        this.map.map.panTo({lat: Number(address.Latitude), lng: Number(address.Longitude)})
        if (this.address !== address.AddressLine) {
          this.address = address.AddressLine
          this.inputvalue = address.Radius
          this.name = address.AddressName
          this.place = {lat: address.AddrSearchString.split(':')[1], lng: address.AddrSearchString.split(':')[0] }
        }
      },
      deleteGeo (keyCode) {
        this.$store.commit('order/deleteGeo', keyCode)
      }
    },
  }
</script>

<style scoped lang="scss">
  .self-btns {
    margin-top: 16px;
  }
  .circle{
    width:100%;
  }
  .header {
    display: flex;    justify-content: space-between;
  }

  .box-t {
    background-color: $color-background;
    width: 100%;
    margin-bottom:16px;
    display: block;
  }

  .form-item {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  }
  .upload-box{
    display: flex;
    align-items: center;
  }
  .form-btn{
    margin-top: 32px;
  }
  .circle{
    margin-top:16px;
  }
  .row{
    margin-top: 16px;
    margin-bottom: 8px;
  }
  .coltitle{
    width:80px;
  }
  .inputcol{
    padding-left: 0px;
  }
  .qty-box {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .qty-radio {
    display: flex;
    flex-direction: column;
  }
  .qty-input {
    width: 120px;
    margin-right: 16px;
  }
  .name-input {
    width: 240px;
    margin-right: 16px;
  }
  .action-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/geo/MMapRadius.vue